import { useState, useEffect } from 'react';
import { headerNavItems } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px] h-[72px] flex items-center justify-between">
          <a href="#hero" className="flex items-center gap-2 no-underline">
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              韩国漫画
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {headerNavItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap px-3 py-2 text-sm font-medium rounded-md text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/60 bg-background-50">
            <div className="px-4 py-3 flex flex-col gap-1">
              {headerNavItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="whitespace-nowrap px-3 py-2.5 text-sm font-medium rounded-md text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}